import cn from "classnames";
import Image from "next/image";
import { AppSettings } from "../lib/get-app-settings";
import styles from "../styles/layout-footer.module.css";
import { HelpCenterFooterLinksMode } from "../lib/load-company-settings";
import UrlIcon from "@atlas/uicorn/lib/Icon/UrlIcon";

type TLayoutFooterProps = {
  className?: string;
  appSettings: AppSettings;
};

export default function LayoutFooter(props: TLayoutFooterProps) {
  const { className, appSettings } = props;

  return (
    <footer className={cn(styles.footer, className)}>
      {appSettings.footerLinksMode !== HelpCenterFooterLinksMode.HIDDEN &&
      appSettings.footerLinks?.length ? (
        <menu className={styles.footerLinks}>
          {appSettings.footerLinks.map((link) => (
            <a
              key={link.id}
              className={styles.footerLink}
              href={link.url}
              title={link.url}
              target="_blank"
            >
              {(appSettings.footerLinksMode ===
                HelpCenterFooterLinksMode.ICONS ||
                appSettings.footerLinksMode ===
                  HelpCenterFooterLinksMode.ICONS_AND_LABELS) &&
                (link.icon ? (
                  <Image
                    className={styles.footerLinkIcon}
                    src={link.icon}
                    data-original={link.icon}
                    itemProp="image"
                    alt={link.label || link.url}
                    width={22}
                    height={22}
                  />
                ) : (
                  <UrlIcon className={styles.footerLinkIcon} url={link.url} />
                ))}{" "}
              {(appSettings.footerLinksMode ===
                HelpCenterFooterLinksMode.LABELS ||
                appSettings.footerLinksMode ===
                  HelpCenterFooterLinksMode.ICONS_AND_LABELS) &&
                (link.label || link.url)}
            </a>
          ))}
        </menu>
      ) : null}
      {appSettings.showAtlasBanner && (
        <a className={styles.footerPowered} href="https://atlas.so">
          Powered by Atlas
        </a>
      )}
    </footer>
  );
}
